import { Navigate, Route, Routes } from 'react-router-dom';
import { PermissionsEnum } from 'consts/permissions';
import SingleContent from 'components/common/layout/SingleContent';
import { PageWrapper } from 'components/common/layout/PageWrapper/PageWrapper';
import { ChildRoute } from 'components/common/types/Route.types';
import PrivateRoute from 'components/common/Auth/Private';
import UserManagementHeader from './UserManagementHeader';
import Roles from './Components/Roles/Roles';
import Users from './Components/Users/Users';

const UserManagement: React.FC = () => {
  const childRoutes: ChildRoute[] = [
    {
      id: 1,
      path: `users`,
      main: () => <SingleContent content={<Users />} />,
      pageAccessPermission: undefined,
    },
    {
      id: 2,
      path: `roles`,
      main: () => <SingleContent content={<Roles />} />,
      pageAccessPermission: PermissionsEnum.USERS_ROLES,
    },
    {
      id: 3,
      path: '*',
      main: () => <Navigate to="users" />,
      pageAccessPermission: undefined,
    },
  ];

  return (
    <PageWrapper>
      <UserManagementHeader />
      <Routes>
        {childRoutes.map((route) => (
          <Route
            key={route.id}
            path={route.path}
            element={<PrivateRoute component={route.main} pageAccessPermission={route.pageAccessPermission} />}
          />
        ))}
      </Routes>
    </PageWrapper>
  );
};

export default UserManagement;
